import { render, staticRenderFns } from "./BulletinUploadForm.vue?vue&type=template&id=209e2120&"
import script from "./BulletinUploadForm.vue?vue&type=script&lang=js&"
export * from "./BulletinUploadForm.vue?vue&type=script&lang=js&"
import style0 from "./BulletinUploadForm.vue?vue&type=style&index=0&id=209e2120&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports